import React from "react";
import { AiFillHome } from "react-icons/ai";
import { BsFillPersonFill, BsFillFileEarmarkCodeFill } from "react-icons/bs";
import { FaLightbulb, FaLink } from "react-icons/fa";
import { useEffect } from "react";

function ToolbarNav() {
  const handleBulbClick = function () {
    const ele = document.body;
    ele.classList.toggle("dark-mode");
  };

  useEffect(() => {
    let interval;
    window.addEventListener("scroll", function () {
      const ele = document.querySelector("#navbar");
      ele.classList.add("hide");
      interval = setInterval(() => {
        ele.classList.remove("hide");
      }, 1500);
    });
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <nav
      id="navbar"
      className="toolbar-nav"
      role="navigation"
      aria-label="Toolbar Navigation"
    >
      <ul className="toolbar-links">
        <li className="toolbar-icons">
          <a href="#">
            <AiFillHome />
          </a>
        </li>
        <li className="toolbar-icons">
          <a href="#about">
            <BsFillPersonFill />
          </a>
        </li>
        <li
          className="toolbar-icons"
          title="Toggle Dark / Light Mode"
          onClick={handleBulbClick}
        >
          <FaLightbulb />
        </li>
        <li className="toolbar-icons">
          <a href="#projects">
            <BsFillFileEarmarkCodeFill />
          </a>
        </li>
        <li className="toolbar-icons">
          <a href="#links">
            <FaLink />
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default ToolbarNav;
